import React from 'react';

function TermsOfUse() {
    return (
        <div style={{ padding: '16px', maxWidth: 900, margin: '0 auto' }}>
            <h1>Terms of Use</h1>
            <p>Last updated: {new Date().toLocaleDateString()}</p>

            <p>
                Please review these terms and conditions carefully before using this website (the
                “Website”). By visiting, accessing, or using the Website, you agree to be bound by
                these Terms of Use (“Terms”). If you do not agree, you must not use the Website.
            </p>

            <h2>1. Eligibility</h2>
            <ul>
                <li>
                    You must be at least eighteen (18) years of age, or the age of majority in your
                    jurisdiction if greater than 18, to use the Website.
                </li>
                <li>Use of the Website is not permitted where prohibited by applicable law.</li>
            </ul>

            <h2>2. Grant of Use</h2>
            <ul>
                <li>
                    We grant you a limited, non-exclusive, non-transferable, revocable license to
                    access and use the Website for personal, non-commercial purposes, subject to
                    these Terms and all applicable policies posted on the Website.
                </li>
                <li>
                    We may terminate or suspend your access at any time, with or without notice, for
                    any reason. Upon termination, you must cease all use of the Website.
                </li>
            </ul>

            <h2>3. Intellectual Property</h2>
            <ul>
                <li>
                    All text, graphics, images, logos, software, and other content available on the
                    Website (collectively, “Proprietary Materials”) are owned by us or our
                    licensors and are protected by copyright, trademark, and other intellectual
                    property laws.
                </li>
                <li>
                    Except as expressly permitted, you may not copy, modify, distribute, publicly
                    display, perform, create derivative works of, or otherwise exploit any
                    Proprietary Materials.
                </li>
            </ul>

            <h2>4. User Submissions</h2>
            <p>
                You are solely responsible for any content, links, data, or materials you upload,
                submit, transmit, or otherwise make available via the Website (“User Submissions”).
                You represent and warrant that you have all rights necessary to provide any User
                Submissions and to grant the licenses described below.
            </p>
            <ul>
                <li>
                    You grant us a worldwide, non-exclusive, royalty-free, sublicensable, and
                    transferable license to use, reproduce, distribute, display, perform, and create
                    derivative works of your User Submissions in connection with operating and
                    improving the Website.
                </li>
                <li>
                    You agree not to upload or share content that infringes the rights of others; is
                    unlawful, harmful, defamatory, harassing, hateful, or otherwise objectionable;
                    or violates these Terms or applicable laws.
                </li>
            </ul>

            <h2>5. Third-Party Content and Links</h2>
            <p>
                The Website may display or link to third-party content and websites that we do not
                control. We are not responsible for third-party content, websites, policies, or
                practices, and your use of them is at your own risk.
            </p>

            <h2>6. Prohibited Uses</h2>
            <p>You agree that you will not:</p>
            <ul>
                <li>Use the Website for any illegal purpose or in violation of any law.</li>
                <li>
                    Violate intellectual property, privacy, or publicity rights, or download,
                    copy, or distribute content without permission from the rights holder.
                </li>
                <li>
                    Interfere with the operation or security of the Website or attempt to gain
                    unauthorized access to systems or networks.
                </li>
                <li>Use automated means to access or scrape the Website without our consent.</li>
            </ul>

            <h2>7. DMCA / Copyright</h2>
            <p>
                If you believe that material on the Website infringes your copyright, please send a
                notice that includes: (a) identification of the copyrighted work; (b) identification
                of the allegedly infringing material and its location; (c) your contact information;
                (d) a statement of good-faith belief that the use is not authorized; (e) a statement
                that the information is accurate and, under penalty of perjury, that you are the
                copyright owner or authorized to act on the owner’s behalf; and (f) your physical or
                electronic signature. We may remove or disable access to the material in our
                discretion. Counter-notifications may be submitted pursuant to applicable law.
            </p>

            <h2>8. Modifications to the Website and Terms</h2>
            <p>
                We may update, change, suspend, or discontinue any part of the Website at any time.
                We may also amend these Terms by posting an updated version on the Website. Your
                continued use of the Website after changes become effective constitutes acceptance of
                the updated Terms.
            </p>

            <h2>9. Indemnification</h2>
            <p>
                You agree to defend, indemnify, and hold harmless us and our affiliates, officers,
                directors, employees, and agents from and against any claims, liabilities, damages,
                losses, and expenses (including reasonable attorneys’ fees) arising out of or in any
                way connected with your use of the Website or your violation of these Terms.
            </p>

            <h2>10. Disclaimer of Warranties</h2>
            <p>
                THE WEBSITE IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND,
                EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR ACCURACY. WE DO NOT WARRANT
                THAT THE WEBSITE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
            </p>

            <h2>11. Limitation of Liability</h2>
            <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL WE BE LIABLE FOR ANY
                INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, OR ANY LOSS OF
                PROFITS, DATA, OR GOODWILL, ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE
                WEBSITE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TO THE EXTENT PERMITTED
                BY LAW, OUR TOTAL LIABILITY FOR ANY CLAIM ARISING UNDER THESE TERMS SHALL NOT EXCEED
                ONE HUNDRED U.S. DOLLARS (USD $100).
            </p>

            <h2>12. Governing Law; Dispute Resolution</h2>
            <p>
                These Terms and your use of the Website are governed by the laws applicable in your
                principal place of business or, if you are an individual, your place of residence,
                without regard to conflict-of-law rules. You agree to the exclusive jurisdiction and
                venue of the courts located there for any disputes arising out of or relating to
                these Terms or the Website.
            </p>

            <h2>13. General Terms</h2>
            <ul>
                <li>These Terms constitute the entire agreement between you and us.</li>
                <li>
                    If any provision is held unenforceable, the remaining provisions will remain in
                    full force and effect.
                </li>
                <li>
                    Our failure to enforce any provision is not a waiver of our right to do so
                    later.
                </li>
                <li>
                    You may not assign these Terms without our prior written consent; we may assign
                    them without restriction.
                </li>
                <li>
                    Notices may be provided via email, posting to the Website, or other reasonable
                    means.
                </li>
            </ul>

            <h2>14. Contact</h2>
            <p>
                If you have questions about these Terms, please contact us through the support or
                contact methods provided on the Website.
            </p>
        </div>
    );
}

export default TermsOfUse;


